import { Button, Grid, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import SelectPlanoContas from "../../../../../../../components/SelectsSimpleApiQuery/SelectPlanoContas";
import BasicDatePicker from "../../../../../../../components/BasicDatePicker";
import SelectOperacoesCCO from "../../../../../../../components/SelectsSimpleApiQuery/SelectOperacoesCCO";
import SelectTipoLancamentos from "../../../../../../../components/SelectsSimpleApiQuery/SelectTipoLancamentos";
import { useMemo } from "react";

export default function Step01() {

  const { getValues, control, handleSubmit, watch, setValue } = useFormContext()

  const handleNext = getValues('funcoesAux.onNext')

  const creditoOuDebito = watch('step01.debito_credito')
  const tipoLancamento = watch('step01.tipo_lancamento')
  const contaCorrente = watch('step01.conta_contabil')

  useMemo(() => {
    const debitoLabel = (creditoOuDebito === "" || tipoLancamento === '' || contaCorrente === '') ? '' : creditoOuDebito === 'D'
      ? `${contaCorrente.codigo_contabil} - ${contaCorrente.nome}` : `${tipoLancamento.conta_contabil} - ${tipoLancamento.nome_conta_contabil}`

    setValue('step01.debito_label', debitoLabel)
  }, [creditoOuDebito, tipoLancamento, contaCorrente, setValue])

  useMemo(() => {
    const creditoLabel = (creditoOuDebito === "" || tipoLancamento === '' || contaCorrente === '') ? '' : creditoOuDebito === 'D'
      ? `${tipoLancamento.conta_contabil} - ${tipoLancamento.nome_conta_contabil}` : `${contaCorrente.codigo_contabil} - ${contaCorrente.nome}`
    setValue('step01.credito_label', creditoLabel)
  }, [creditoOuDebito, tipoLancamento, contaCorrente, setValue])

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step01.conta_contabil"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid } }) => (
            <SelectPlanoContas
              inputLabel="Conta corrente"
              value={field.value}
              required
              error={invalid}
              onChangeValue={(valor) => field.onChange(valor)}
              extraParams={{ sistema_xy: "D-CON" }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step01.data_lancamentos"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid } }) => (
            <BasicDatePicker
              label="Data dos lançamentos"
              value={field.value}
              formatString="DD/MM/YYYY"
              error={invalid}
              onChange={(data) => { field.onChange(data) }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <Controller
          name="step01.operacao"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid } }) => (
            <SelectOperacoesCCO
              value={field.value}
              error={invalid}
              onChange={(valor) => { field.onChange(valor) }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 5 }}>
        <Controller
          name="step01.tipo_lancamento"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <SelectTipoLancamentos
              {...field}
              required
              error={invalid}
              value={field.value}
              onChange={(valor) => {
                field.onChange(valor)
                setValue('step01.debito_credito', valor?.tipo_movimento)
              }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 3 }}>
        <Controller
          name="step01.debito_credito"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              required
              error={invalid}
              fullWidth
              label="D/C"
              value={field.value}
              onChange={(valor) => {
                const newValue = valor.target.value.toUpperCase();
                if (newValue === 'D' || newValue === 'C' || newValue === '') {
                  field.onChange(newValue);
                }
              }}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step01.debito_label"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              required
              error={invalid}
              label={'Débito / CC'}
              fullWidth
              slotProps={{
                input: { readOnly: true }
              }}
              value={field.value}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />

      </Grid>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step01.credito_label"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              required
              error={invalid}
              label={'Crédito / CC'}
              fullWidth
              slotProps={{
                input: { readOnly: true }
              }}
              value={field.value}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />

      </Grid>
      <Grid size={{ xs: 12 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit(handleNext)}
        >
          Avançar
        </Button>
      </Grid>
    </Grid>
  )
}
